import { isClient as e } from "../server-side/is-client.mjs";
import { useCallback as t, useMemo as n } from "react";
//#region src/storage/use-storage.ts
var r = (r, i = {}) => {
	let { parser: a = JSON.parse, stringifier: o = JSON.stringify, useSessionStorage: s } = i, c = n(() => {
		if (e()) return s ? window.sessionStorage : window.localStorage;
	}, [s]);
	return {
		setItem: t((e) => {
			r && c && c.setItem(r, o(e));
		}, [
			r,
			c,
			o
		]),
		getItem: t(() => {
			if (!r || !c) return;
			let e = c.getItem(r);
			return e ? a(e) : null;
		}, [
			r,
			c,
			a
		]),
		removeItem: t(() => {
			r && c && c.removeItem(r);
		}, [r, c]),
		removeByPrefix: t((e) => {
			c && Object.keys(c).forEach((t) => {
				t.startsWith(e) && c.removeItem(t);
			});
		}, [c])
	};
};
//#endregion
export { r as useStorage };
